import Typed from 'typed.js'

var typedElements = document.querySelectorAll(".js-typed");
var typedElementsMobile = document.querySelectorAll(".js-typed-mobile");

const options = {
  strings: ['Give now', 'Send Rescue'],
  typeSpeed: 200,
  backSpeed: 150,
  startDelay: 500,
  backDelay: 2500,
  loop: true
}

if (typedElements.length)
{
  const typed = new Typed('.js-typed', options)
}

if (typedElementsMobile.length)
{
  const typedMobile = new Typed('.js-typed-mobile', options)
}